/*
 * @Author: zuoxuecheng
 * @Date: 2024-07-09 14:21:45
 * @Description: 在此处清晰,简洁的说明本文件的作用
 */
import router from "@/router";
import Vue from "vue";
import global from "@/utils/global.js";
import { createApplication } from "@/utils/host_application";

const vm = Vue.prototype;
const app = createApplication()

const printer = {
  state: {
    cur_printer: null,
    cur_task: null,
    lan_printer_list: [],
    cloud_printer_list: [],
    printer_type: "", //cloud 云打印机 lan 局域网打印机
    layoutLoadingFlag: false, // layout -- loding -- 开关
    lanLayoutLoading: false, // 区分业务
    cur_before_task: null, //  打印前机器的消息处理
    error_id_data: {}, //  错误码
    lan_mqtt: null, // 打印机连接mqtt数据
    isSubscribe: false, //  是否订阅了消息
    lanRetryCount: global.lanCount, // 局域网下重连次数
    cloudIsSelectId: null,  //  广域网当前选择的机器id
    setting_list: [
      {
        machine_type: 20021,
        name: "Anycubic Kobra 2 Pro",
        temp_limit: {
          hotbed_temp_limit: [45, 110],
          nozzle_temp_limit: [185, 260]
        },
        fan_limit: [0, 100],
        aux_fan_speed_limit: [],
        box_fan_level_limit: []
      },
      {
        machine_type: 20022,
        name: "Anycubic Kobra 2 Plus",
        temp_limit: {
          hotbed_temp_limit: [45, 90],
          nozzle_temp_limit: [185, 260]
        },
        fan_limit: [0, 100],
        aux_fan_speed_limit: [],
        box_fan_level_limit: []
      },
      {
        machine_type: 20023,
        name: "Anycubic Kobra 2 Max",
        temp_limit: {
          hotbed_temp_limit: [45, 90],
          nozzle_temp_limit: [185, 260]
        },
        fan_limit: [0, 100],
        aux_fan_speed_limit: [],
        box_fan_level_limit: []
      },
      {
        machine_type: 20024,
        name: "Anycubic Kobra 3",
        temp_limit: {
          hotbed_temp_limit: [45, 110],
          nozzle_temp_limit: [185, 300]
        },
        fan_limit: [0, 100],
        aux_fan_speed_limit: [],
        box_fan_level_limit: []
      },
      {
        machine_type: 20025,
        name: "Anycubic Kobra S1",
        temp_limit: {
          hotbed_temp_limit: [45, 120],
          nozzle_temp_limit: [185, 320]
        },
        fan_limit: [0, 100],
        aux_fan_speed_limit: [0, 100],
        box_fan_level_limit: [0, 100]
      },
      {
        machine_type: 20026,
        name: "Anycubic Kobra 3 Max",
        temp_limit: {
          hotbed_temp_limit: [45, 90],
          nozzle_temp_limit: [185, 260]
        },
        fan_limit: [0, 100],
        aux_fan_speed_limit: [0, 100],
        box_fan_level_limit: [0, 100]
      }
    ],
    haveTip: 0, // 局域网 0无提示 1重连 2设备发现 3连接失败
    retryUid: "", // 局域网重连uid
    userDownloadList: [], //  用户下载文件，软件回调函数，以用户id为单位存储
    modelSkipArr: [],
    printerFileDetails: {},// 机器详情中零件跳过信息
    skipObjStorage: {
      cloud: {},
      lan: {}
    },  //  缓存零件跳过信息（新增，修改）
    cloudInfoRefresh: null //  云打印机详情是否重新刷新数据
  },
  mutations: {
    SET_RETRY_UID(state, data) {
      state.retryUid = data;
    },
    SET_HAVE_TIP(state, data) {
      state.haveTip = data;
    },
    SET_TIP_TEXT(state, data) {
      state.tipText = data;
    },
    SET_SETTING_LIST(state, data) {
      state.setting_list = data;
    },
    SET_CUR_PRINTER(state, data) {
      app.config_write('current_device_id', JSON.stringify(data?.deviceId || data?.key))
      state.cur_printer = data;
    },
    SET_CUR_TASK(state, data) {
      state.cur_task = data;
    },
    DEL_CUR_PRINTER(state) {
      state.cur_printer = null;
    },
    DEL_CUR_TASK(state) {
      state.cur_task = null;
    },
    SET_LAN_PRINTER_LIST(state, data) {
      let uniqueData = Array.from(new Set(data.map(JSON.stringify))).map(JSON.parse);
      app.config_write('machine_list_of_LAN', JSON.stringify(uniqueData))
      state.lan_printer_list = uniqueData;
    },
    GET_LAN_PRINTER_LIST_SLICE(state, data) {
      state.lan_printer_list = data;
    },
    SET_CLOUD_PRINTER_LIST(state, data) {
      state.cloud_printer_list = data;
    },
    DEL_LAN_PRINTER_LIST(state) {
      state.lan_printer_list = [];
    },
    DEL_CLOUD_PRINTER_LIST(state) {
      state.cloud_printer_list = [];
    },
    SET_PRINTER_TYPE(state, data) {
      state.printer_type = data;
    },
    DEL_PRINTER_TYPE(state) {
      state.printer_type = "";
    },
    SET_LAYOUT_LOADING(state, data) {
      state.layoutLoadingFlag = data;
    },
    SET_LAN_LAYOUT_LOADING(state, data) {
      state.lanLayoutLoading = data;
    },
    SET_CUR_BEFORE_TASK(state, data) {
      state.cur_before_task = data;
    },
    SET_ERROR_ID_DATA(state, data) {
      state.error_id_data = data;
    },
    SET_LAN_MQTT(state, data) {
      state.lan_mqtt = data;
    },
    DEL_LAN_MQTT(state, data) {
      state.lan_mqtt = null;
    },
    SET_SUBSCRIBE(state, data) {
      state.isSubscribe = data;
    },
    SET_LAN_STATUS_EMPTY(state, data) {
      let index = state.lan_printer_list.findIndex(
        (i) => i.uuid == data?.uuid || i.deviceId === data?.deviceId
      );
      if (index != -1) {
        state.lan_printer_list[index].status = "";
      }
      if (state.cur_printer && state.cur_printer?.deviceId == data?.deviceId) {
        state.cur_printer.status = ''
      }
    },
    SET_LAN_RETRY_COUNT(state, data) {
      state.lanRetryCount = data;
    },
    SET_CLOUD_IS_SELECT_ID(state, data) {
      state.cloudIsSelectId = data;
    },
    //  新增：云文件下载成功，本地缓存下载完成md5值做二次文件唯一性校验(以用户为单位存储)
    //  重命名与删除需要判断是否本地下载过，做对应维护
    SET_USER_DOWNLOAD_LIST (state, data) {
      let uniqueData = Array.from(new Set(data.map(JSON.stringify))).map(JSON.parse);
      app.config_write('SET_USER_DOWNLOAD_LIST', JSON.stringify(uniqueData))
      state.userDownloadList = data;
    },
    GET_USER_DOWNLOAD_LIST (state, data) {
      state.userDownloadList = data;
    },
    //  零件跳过新增,存储零件跳过信息，前端存储已经跳过的零件信息（任务改变清空该信息）
    SET_MODEL_SKIP_OBJ(state, data) {
      state.modelSkipArr = data;
    },
    SET_PRINTER_FILE_DETAILS(state, data) {
      state.printerFileDetails = data;
    },
    SET_CLOUD_SKIP_OBJ(state, data) {
      state.skipObjStorage['cloud'] = data;
    },
    SET_LAN_SKIP_OBJ(state, data) {
      state.skipObjStorage['lan'] = data;
    },
    SET_CLOUD_INFO_REFRESH (state, data) {
      state.cloudInfoRefresh = data;
    },
  },
  actions: {
    SET_CUR_PRINTER({ commit }, data) {
      commit("SET_CUR_PRINTER", data);
    },
    SET_CUR_TASK({ commit }, data) {
      commit("SET_CUR_TASK", data);
    },
    DEL_CUR_PRINTER({ commit }, data) {
      commit("SET_CUR_PRINTER", data);
    },
    DEL_CUR_TASK({ commit }, data) {
      commit("SET_CUR_TASK", data);
    },
    SET_LAN_PRINTER_LIST({ commit }, data) {
      commit("SET_LAN_PRINTER_LIST", data);
    },
    SET_CLOUD_PRINTER_LIST({ commit }, data) {
      commit("SET_CLOUD_PRINTER_LIST", data);
    },
    SET_LOADING_TRUE({ commit }) {
      commit("SET_LAYOUT_LOADING", true);
    },
    SET_LOADING_FALSE({ commit }) {
      commit("SET_LAYOUT_LOADING", false);
    },
    SET_LAN_MQTT({ commit }, data) {
      commit('SET_LAN_MQTT', data)
    },
    async GET_LAN_PRINTER_LIST_SLICE({ commit }, data) {
      const res = await app.config_read('machine_list_of_LAN')
      const arr = res ? JSON.parse(res) : []
      commit('GET_LAN_PRINTER_LIST_SLICE', arr)
    },
    async GET_USER_DOWNLOAD_LIST ({ commit }, data) {
      const res = await app.config_read('SET_USER_DOWNLOAD_LIST')
      const arr = res ? JSON.parse(res) : []
      arr.length > 0 && commit('GET_USER_DOWNLOAD_LIST', arr)
    }
  },
  getters: {
    GET_CUR_PRINTER: (state) => state.cur_printer,
    GET_CUR_TASK: (state) => state.cur_task,
    GET_LAN_PRINTER_LIST: (state) => state.lan_printer_list,
    GET_CLOUD_PRINTER_LIST: (state) => state.cloud_printer_list,
    GET_PRINTER_TYPE: (state) => state.printer_type,
    GET_LAYOUT_LOADING: (state) => state.layoutLoadingFlag,
    GET_LAN_LAYOUT_LOADING: (state) => state.lanLayoutLoading,
    GET_ERROR_ID_DATA: (state) => state.error_id_data,
    GET_LAN_MQTT: (state) => state.lan_mqtt,
    GET_SUBSCRIBE: (state) => state.isSubscribe,
    GET_LAN_RETRY_COUNT: (state) => state.lanRetryCount,
    GET_SETTING_LIST: (state) => state.setting_list,
    GET_HAVE_TIP: (state) => state.haveTip,
    GET_TIP_TEXT: (state) => state.tipText,
    GET_RETRY_UID: (state) => state.retryUid,
    GET_CLOUD_IS_SELECT_ID: (state) => state.cloudIsSelectId,
    GET_MODEL_SKIP_OBJ: (state) => state.modelSkipArr,
    GET_PRINTER_FILE_DETAILS: (state) => state.printerFileDetails,
    GET_CLOUD_SKIP_OBJ: (state) => state.skipObjStorage['cloud'],
    GET_LAN_SKIP_OBJ: (state) => state.skipObjStorage['lan'],
    GET_CLOUD_INFO_REFRESH: (state) => state.cloudInfoRefresh,
  }
};

export default printer;
